module.exports = __webpack_public_path__ + "static/media/routes11.e54ccfc6.webp";